import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getSimDetails = async (token, simId) => {
    log("welcome in getSimDetails for simId=" + simId)

    if (!token || token === "") {
        return {error: true, message: "No token provided", sim: null}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_sim_details_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers, params: {id: simId}})
        log("result.data din axios getSimDetails")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSimDetails")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getSimDetails", sim: null}
    }
}

export const getSimsList = async (token, options = {}) => {
    log("welcome in getSimsList")

    if (!token || token === "") {
        alert("No token in getSimsList")
        return {error: true, message: "No token provided", sims: [], total_count: 0}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_sims_list_api'
        log("url=" + url)

        // Build query params
        const params = {}

        if (options.search_term) {
            params.search_term = options.search_term
        }
        if (options.sim_status_id !== undefined) {
            params.sim_status_id = options.sim_status_id
        }
        if (options.client_id) {
            params.client_id = options.client_id
        }
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }
        if (options.sort_by) {
            params.sort_by = options.sort_by
        }
        if (options.sort_order) {
            params.sort_order = options.sort_order
        }
        if (options.page) {
            params.page = options.page
        }
        if (options.per_page) {
            params.per_page = options.per_page
        }
        if (options.sim_id) {
            params.sim_id = options.sim_id
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getSimsList")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSimsList")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getSimsList", sims: [], total_count: 0}
    }
}

export const getSimStatuses = async (token) => {
    log("welcome in getSimStatuses")

    if (!token || token === "") {
        return {error: true, message: "No token provided", sim_statuses: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_sim_statuses_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getSimStatuses")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSimStatuses")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getSimStatuses", sim_statuses: []}
    }
}

export const provisionSim = async (token, sim_id, msisdn_id, imsi_id = null, mno_product = null, client_service_id = null) => {
    log("welcome in provisionSim for sim_id=" + sim_id + ", msisdn_id=" + msisdn_id + ", imsi_id=" + imsi_id + ", mno_product=" + mno_product + ", client_service_id=" + client_service_id)
    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/provision_sim_api'
        log("url=" + url)

        const payload = {sim_id: sim_id, msisdn_id: msisdn_id}
        if (imsi_id) {
            payload.imsi_id = imsi_id
        }
        if (mno_product) {
            payload.mno_product = mno_product
        }
        if (client_service_id) {
            payload.client_service_id = client_service_id
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios provisionSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in provisionSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la provisionSim"}
    }
}

export const terminateSim = async (token, sim_id, imsi_id = null) => {
    log("welcome in terminateSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/terminate_sim_subscription_api'
        log("url=" + url)

        const payload = {sim_id: sim_id, deprovision:true}
        if (imsi_id) {
            payload.imsi_id = imsi_id
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios provisionSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in provisionSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la provisionSim"}
    }
}

export const getAvailableImsisForProvision = async (token, sim_id, search_term = '', client_id = null) => {
    log("welcome in getAvailableImsisForProvision for sim_id=" + sim_id + ", client_id=" + client_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided", imsis: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_available_imsis_for_provision_api'
        log("url=" + url)

        const params = {}
        if (sim_id) {
            params.sim_id = sim_id
        }
        if (client_id) {
            params.client_id = client_id
        }
        if (search_term) {
            params.search_term = search_term
        }

        const result = await axios.get(url, {headers: headers, params: params})
        log("result.data din axios getAvailableImsisForProvision")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getAvailableImsisForProvision")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getAvailableImsisForProvision", imsis: []}
    }
}

// Legacy function for backwards compatibility
export const getAvailableImsisForClient = getAvailableImsisForProvision

export const refreshSim = async (token, sim_id) => {
    log("welcome in refreshSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/refresh_sim_api'
        log("url=" + url)

        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios refreshSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in refreshSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la refreshSim"}
    }
}

export const terminateSimOld = async (token, sim_id, deprovision = false) => {
    log("welcome in terminateSim for sim_id=" + sim_id + ", deprovision=" + deprovision)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/terminate_sim_api'
        log("url=" + url)

        const result = await axios.post(url, {sim_id: sim_id, deprovision: deprovision}, {headers: headers})
        log("result.data din axios terminateSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in terminateSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la terminateSim"}
    }
}

export const suspendSim = async (token, sim_id) => {
    log("welcome in suspendSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/suspend_sim_api'
        log("url=" + url)

        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios suspendSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in suspendSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la suspendSim"}
    }
}

export const reactivateSim = async (token, sim_id) => {
    log("welcome in reactivateSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/reactivate_sim_api'
        log("url=" + url)

        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios reactivateSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in reactivateSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la reactivateSim"}
    }
}

export const changeSimMsisdn = async (token, sim_id, new_msisdn_id) => {
    log("welcome in changeSimMsisdn for sim_id=" + sim_id + ", new_msisdn_id=" + new_msisdn_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/change_sim_msisdn_api'
        log("url=" + url)

        const result = await axios.post(url, {sim_id: sim_id, new_msisdn_id: new_msisdn_id}, {headers: headers})
        log("result.data din axios changeSimMsisdn")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in changeSimMsisdn")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la changeSimMsisdn"}
    }
}

export const updateSim = async (token, sim_id, data) => {
    log("welcome in updateSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_sim_api'
        log("url=" + url)

        const result = await axios.put(url, {sim_id: sim_id, ...data}, {headers: headers})
        log("result.data din axios updateSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateSim"}
    }
}

export const renewClientService = async (token, sim_id) => {
    log("welcome in renewClientService for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/renew_sim_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios renewClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in renewClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la renewClientService"}
    }
}

export const reprovisionTerminatedSim = async (token, imsi_id, msisdn_id, mno_product) => {
    log("welcome in reprovisionTerminatedSim for imsi_id=" + imsi_id + ", msisdn_id=" + msisdn_id + ", mno_product=" + mno_product)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    if (!imsi_id) {
        return {error: true, message: "imsi_id is required"}
    }

    if (!msisdn_id) {
        return {error: true, message: "msisdn_id is required"}
    }

    if (!mno_product) {
        return {error: true, message: "mno_product is required"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        const payload = {
            imsi_id: imsi_id,
            msisdn_id: msisdn_id,
            mno_product: mno_product
        }

        let url = BASE_URL + '/home/reprovision_terminated_imsi_api'
        const result = await axios.post(url, payload, {headers: headers})
        log("result.data from reprovisionTerminatedSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in reprovisionTerminatedSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Error reprovisioning terminated SIM"}
    }
}

export const getSimsStats = async (token) => {
    log("welcome in getSimsStats")

    if (!token || token === "") {
        return {error: true, message: "No token provided", stats: {}}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_sims_stats_api'
        const result = await axios.get(url, {headers: headers})
        log("result.data from getSimsStats")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSimsStats")
        log(err)
        error.value = err.message
        return {error: true, message: "Error fetching SIM stats", stats: {}}
    }
}

const useGetSimsAPI = () => {
    return {
        error,
        getSimDetails,
        getSimsList,
        getSimStatuses,
        provisionSim,
        getAvailableImsisForClient,
        refreshSim,
        terminateSim,
        suspendSim,
        reactivateSim,
        changeSimMsisdn,
        updateSim,
        renewClientService,
        reprovisionTerminatedSim
    }
}

export default useGetSimsAPI
